export default __webpack_public_path__ + "static/media/search-icon.3971e3e2.svg";